import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/select";
import { Checkbox } from "components/ui/checkbox";

interface Permission {
  perm_key: string;
  perm_desc: string;
  allowed: boolean;
}

interface AccessLevel {
  id: number;
  name: string;
}

interface PermissionsTabProps {
  selectedRole: any;
  accessLevels: AccessLevel[];
  updatingAccessLevel: boolean;
  updatingPermissions: boolean;
  handleAccessLevelChange: (newAccessLevelId: string) => void;
  handlePermissionToggle: (permKey: string) => void;
}

const PermissionsTab: React.FC<PermissionsTabProps> = ({
  selectedRole,
  accessLevels,
  updatingAccessLevel,
  updatingPermissions,
  handleAccessLevelChange,
  handlePermissionToggle,
}) => {
  return (
    <div className="flex flex-col h-full min-h-0 space-y-6">
      <div>
        <h3 className="text-sm font-medium mb-2">Access Level</h3>
        <Select
          value={selectedRole.access_level_id ? String(selectedRole.access_level_id) : "all"}
          onValueChange={handleAccessLevelChange}
          disabled={updatingAccessLevel}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All</SelectItem>
            {accessLevels.map(level => (
              <SelectItem key={level.id} value={String(level.id)}>
                {level.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex-1 min-h-0 flex flex-col">
        <h3 className="text-sm font-medium mb-3">Permissions</h3>
        <div className="flex-1 overflow-y-auto space-y-2 pr-1">
          {selectedRole.permissions.length === 0 ? (
            <div className="text-center py-8 text-muted-foreground text-sm">
              No permissions available for this role
            </div>
          ) : (
            selectedRole.permissions.map((permission: Permission) => (
              <div
                key={permission.perm_key}
                className="flex items-center justify-between p-3 rounded-lg border border-border hover:bg-muted/30 transition-colors"
              >
                <span className="font-medium text-sm">{permission.perm_desc}</span>
                <Checkbox
                  checked={permission.allowed}
                  onCheckedChange={() => handlePermissionToggle(permission.perm_key)}
                  disabled={updatingPermissions}
                />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default PermissionsTab;